export default __webpack_public_path__ + "static/media/diversity2.338c5860.webp";